import { render, staticRenderFns } from "./EvolutionMainNumberOpinion.vue?vue&type=template&id=eaf69f20&lang=pug"
import script from "./EvolutionMainNumberOpinion.vue?vue&type=script&lang=js"
export * from "./EvolutionMainNumberOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports